import { Transition, Variants, motion } from "framer-motion";
import isEqual from "lodash/isEqual";
import { FC, memo } from "react";
import { Outlet, useLocation } from "react-router-dom";

type AnimatedLayoutProps = {
  variants: Variants;
  transition: Transition;
  className?: string;
};

const AnimatedLayout: FC<AnimatedLayoutProps> = ({
  variants,
  transition,
  className,
}) => {
  const { pathname } = useLocation();

  return (
    <motion.div
      key={pathname}
      initial="initial"
      animate="in"
      variants={variants}
      transition={transition}
      className={className}
    >
      <Outlet />
    </motion.div>
  );
};

export default memo(AnimatedLayout, isEqual);
